
import React, {useState} from 'react';

const styles={
    container:{
        height:'100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',   
        backgroundColor:'',
        color:'black',
        backgroundColor:'grey',
        opacity:'0.4',
        fontSize:28
    }    
  }


export default () => <div style={styles.container}>
    <h2>Page not found</h2>
</div>


